<template>
    <table>
        <thead>
        <tr>
            <th>
                {{ $t('eventRegistration.invoicePreview.article') }}
            </th>
            <th class="text-right">
                {{ $t('eventRegistration.invoicePreview.quantity') }}
            </th>
            <th class="text-right">
                {{ $t('eventRegistration.invoicePreview.price') }}
            </th>
        </tr>
        </thead>
        <tbody>
        <InvoiceArticlesGroup v-for="(invoiceArticlesGroup, name) in getAllInvoiceArticlesGroupedByArticle"
                              :key="name"
                              :isDecimalPrice="isDecimalPrice"
                              :invoiceArticlesGroup="invoiceArticlesGroup">
        </InvoiceArticlesGroup>
        <tr v-if="!getAllInvoiceArticlesGroupedByArticle || !Object.keys(getAllInvoiceArticlesGroupedByArticle).length">
            <td>
                {{ $t('eventRegistration.invoicePreview.noArticles') }}
            </td>
        </tr>
        <tr>
            <td>
            </td>
            <td colspan="2" class="text-right text-nowrap font-weight-bold">
                <div>
                    <div v-if="getCouponTotal > 0">
                        <span class="mr-3">{{ $t('eventRegistration.invoicePreview.redeemedCoupons') }}:</span>
                        <span>- {{ convertToHumanNumber(getCouponTotal, isDecimalPrice) }} {{ currencySymbol }}</span>
                    </div>
                </div>
            </td>
        </tr>
        <tr>
            <td>
            </td>
            <td colspan="2" class="text-right text-nowrap">
                <div class="total" v-show="!hideTotal">
                    <div>
                        <span class="mr-3">{{ $t('eventRegistration.invoicePreview.total') }}:</span>
                        <span>{{ convertToHumanNumber(getInvoiceTotal - getCouponTotal, isDecimalPrice) }}
                            {{ currencySymbol }}</span>
                    </div>
                </div>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
import registrationPriceMixin from "@/mixins/registration/registrationPriceMixin";
import InvoiceArticlesGroup from "@/components/pages/registration/InvoiceArticlesGroup";

export default {
    name: "InvoicePreview",
    components: {InvoiceArticlesGroup},
    mixins: [registrationPriceMixin],
    props: {
        hideTotal: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isDecimalPrice() {
            let articleGroups = this.getAllInvoiceArticlesGroupedByArticle
            for (let group in articleGroups) {
                if (articleGroups.hasOwnProperty(group)) {
                    for (let article of articleGroups[group]) {
                        if (article.isGross && article.unitPrice % 1 !== 0) {
                            return true
                        } else if (!article.isGross && article.unitPrice * (article.tax / 100 + 1) % 1 !== 0) {
                            return true
                        }
                    }
                }
            }
            if (this.getCouponTotal % 1 !== 0) return true
            return false
        }
    }
}
</script>

<style lang="scss" scoped>
table {
    th:first-child, ::v-deep td:first-child {
        width: 100%; /* Extend the cell as much as possible */
        max-width: 0; /* Avoid resizing beyond table width */
    }

    th, ::v-deep td {
        padding: map-get($spacers, 1) map-get($spacers, 2);
        vertical-align: top;
    }

    th:first-child, ::v-deep td:first-child {
        padding-left: 0
    }

    th:last-child, ::v-deep td:last-child {
        padding-right: 0
    }

    .total {
        font-weight: $font-weight-bold;
    }

    .total::before {
        content: '';
        width: 100%;
        height: 1px;
        display: block;
        background: $body-color;
    }
}
</style>
